import { createContext, useContext } from "react";
import { createPortal } from "react-dom";

/**
 * DOM node rendered by AssessmentPanel below its border, where every
 * assessment sends its Back / Next / Save controls.
 */
export const AssessmentActionsSlotContext = createContext(null);

/**
 * The questionnaire library renders its buttons inside its own form, so the
 * controls cannot be placed outside the panel without leaving the form. The
 * actions are therefore rendered by the consumer and submit the form
 * explicitly, which also keeps the saving state next to the mutation that
 * owns it.
 *
 * @param {HTMLElement} element node inside or around the questionnaire form
 */
export const submitQuestionnaireForm = (element) => {
    const form =
        element?.closest?.("form") ||
        element?.querySelector?.("form") ||
        element?.parentElement?.closest?.("form");

    if (!form) {
        return;
    }

    if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
        return;
    }

    form.dispatchEvent(
        new Event("submit", { bubbles: true, cancelable: true })
    );
};

/**
 * Renders assessment controls into the panel's actions slot. Falls back to
 * rendering in place when used outside an AssessmentPanel.
 */
const AssessmentActions = ({ children }) => {
    const slot = useContext(AssessmentActionsSlotContext);

    const actions = (
        <div className="assessment-panel__actions">{children}</div>
    );

    return slot ? createPortal(actions, slot) : actions;
};

export default AssessmentActions;
